"use client";

import {
  getCachedProjects,
  type RecentCacheEviction,
  recordRecentCacheEviction,
  removeProjectCacheBundle,
} from "./cache-inventory";

export function isQuotaExceededError(error: unknown): boolean {
  if (typeof DOMException !== "undefined" && error instanceof DOMException) {
    return (
      error.name === "QuotaExceededError" ||
      error.name === "NS_ERROR_DOM_QUOTA_REACHED"
    );
  }
  if (
    error &&
    typeof error === "object" &&
    "name" in error &&
    typeof error.name === "string"
  ) {
    return (
      error.name === "QuotaExceededError" ||
      error.name === "NS_ERROR_DOM_QUOTA_REACHED"
    );
  }
  return false;
}

export function evictOldestProjectCache(options?: {
  protectedProjectId?: number | null;
}): RecentCacheEviction | null {
  const candidate = getCachedProjects({
    currentProjectId: options?.protectedProjectId ?? null,
  })[0];
  if (!candidate) return null;

  const { freedBytes, projectTitle } = removeProjectCacheBundle(
    candidate.projectId,
  );
  const eviction: RecentCacheEviction = {
    projectId: candidate.projectId,
    projectTitle,
    evictedAt: new Date().toISOString(),
    freedBytes,
  };
  recordRecentCacheEviction(eviction);
  console.warn("[cache-eviction] evicted project cache", eviction);
  return eviction;
}

export function retryWithProjectCacheEviction<T>(
  operation: () => T,
  options?: {
    protectedProjectId?: number | null;
  },
): T {
  while (true) {
    try {
      return operation();
    } catch (error) {
      if (!isQuotaExceededError(error)) throw error;
      const eviction = evictOldestProjectCache({
        protectedProjectId: options?.protectedProjectId ?? null,
      });
      if (!eviction) throw error;
    }
  }
}
